<template>
   <div class="content-wrapper pl-3 pr-3 pb-3 pt-3 mb-2" style="height: inherit; width:inherit;">
    <!-- Content Header (Page header) -->
        <div v-if="$gate.isSysAdmin()">
<!-- Whatever VUE CONTENT: PLACE IT AFTER THIS COMMENT -->
            
    <section class="content-header">
        <div class="container-fluid">
          <div class="row mb-2">
            <div class="col-sm-6">
              <h2>SALES | Terms And Conditions</h2>
            </div>
            <div class="col-sm-6">
              <ol class="breadcrumb float-sm-right">
                <li class="breadcrumb-item"><a href="/home">Home</a></li>
                <li class="breadcrumb-item active">{{ $route.meta.title }}</li>
              </ol>
            </div>
          </div>
        </div><!-- /.container-fluid -->
      </section>

    <!-- Main content -->
    <section class="content">
<br>
<!-- main row for all icons  -->
<div class="col-md-12 center center-block" align="center">
<div class="col-md-10">
<div class="row">


<!-- content here -->
<div class="card">
                    <div class="card-header">Add/Modify Terms And Conditions + Privacy Policy</div>

                    <div class="card-body">
                      
                      <div id="app">
                        <button @click="setEditorContent">Load Latest Terms and Policy</button>
                        <br>
                        <input type="hidden" name="type" values="SALES">
                        <br>
                        <vue-editor v-model="htmlForEditor"></vue-editor>
                        <br>
                        <br>
                        <button class="btn btn-primary" @click="addTerms">Add Terms</button>
                       </div>
                         <!-- <froala id="edit" :tag="'textarea'" :config="config" v-model="model"></froala> -->
                    </div>
                </div>

</div>
</div>
</div>
<!-- row end -->
    </section>
    <!-- /.content -->


    
<!-- All VUE Parts end before this comment -->
        </div>
        <div v-if="!$gate.isSysAdmin()">
             <access-denied></access-denied>
        </div>
    </div>
</template>

<script src="https://cdn.quilljs.com/1.3.6/quill.js"></script>

<script>

import { VueEditor } from "vue2-editor";

export default {
  components: {
    VueEditor
  },

  data() {
    return {
      htmlForEditor: null
    };
  },

  methods: {
    setEditorContent: function() {
    	axios.post("/api/getLatestSalesTerms")
    	.then(response => {
    		this.htmlForEditor = response.data.terms;
    	})
    },
    
    addTerms(){
    	axios.post("/api/addSalesTerms", {term: this.htmlForEditor})
    	.then(() => {
    		toast.fire({
      	  type: 'success',
          title: 'Terms Added'
        });
    	})
    }
  },
  mounted()
  {
      console.log('Terms And Conditions Component mounted.')
  }
}

</script>
